module.exports = __webpack_public_path__ + "assets/5bf952a3a16e5008551c220c39d079ab.svg";